import ProductCard from 'common/components/Card/ProductCard'
import Skeleton from 'common/components/Skeleton'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import { pathToCdn } from 'lib/cdn'
import { useTranslation } from 'react-i18next'
import { useStoreState } from 'stores/hooks'
import styled from 'styled-components'

const backgroundImage = pathToCdn(
  '/assets/img/background-product-recommendation.png',
)

const ProductSectionWrapper = styled.section`
  width: 100%;
  max-width: 1140px;
  margin: 24px auto;
  background: url(${backgroundImage}) center/cover;
  padding: 32px;
  border-radius: 20px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.1);
`

const SectionTitle = styled(Typography)`
  font-size: 28px;
  font-weight: 700;
  color: ${theme.colors.black};
`

const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  padding-top: 16px;
`

const SectionBlock = styled.div`
  margin-bottom: 20px;
`

const SkeletonWrapper = styled.div`
  width: 100%;
`
function ProductRecommendation(): JSX.Element {
  const { t } = useTranslation('home')
  const { data: recommendationsData } = useStoreState(
    (states) => states.recommendations,
  )
  const recommendations = recommendationsData?.items ?? []
  const renderSkeletons = () =>
    new Array(6).fill(0).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <SkeletonWrapper key={`product-skeleton-${index}`}>
        <Skeleton width="100%" height="323px" />
      </SkeletonWrapper>
    ))

  const renderProducts = (items) => {
    const limitedItems = items.slice(0, 6)

    if (!limitedItems.length) {
      return renderSkeletons()
    }

    return limitedItems.map((product) => (
      <ProductCard
        key={product.itemId}
        type="recomendation"
        image={product.imageUrl}
        name={product.itemName}
        currentPrice={String(product.priceDiscount || product.price)}
        previousPrice={String(product.price)}
        storeName={product.sellerName}
        rating={product.ratingReview}
        productURL={`${WEB_DESKTOP_RALALI_URL}${product.redirectUrl}`}
        unit={`Per ${product.unitType}`}
        isShowRating
        percentage={`${product.discountPercentage}%`}
      />
    ))
  }

  return (
    <ProductSectionWrapper>
      <SectionBlock>
        <SectionTitle type="bh2">
          {t('RECOMMENDATED_PRODUCTS', { ns: 'home' })}
        </SectionTitle>
        <ProductsGrid>
          {recommendations.length
            ? renderProducts(recommendations)
            : renderSkeletons()}
        </ProductsGrid>
      </SectionBlock>
    </ProductSectionWrapper>
  )
}

export default ProductRecommendation
